module.exports = __webpack_public_path__ + "img/logo_bob_black.9adb234a.svg";